import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "reactstrap";
import SessionContext from "SessionContext";
import { useGlobalState } from "hooks/useGlobalState";

export default function CompanySettings() {
  const session = useContext(SessionContext);
  const access = session.appState.userCan;
  const { companyHasExternalDestinations } = useGlobalState();
 
  const settingsLinks = [];
  const [allowsExternalDestinations, setAllowsExternalDestinations] = useState(false);

  // if the current company doesn't allow creation of sub-companies: hide links to reseller settings
  const current_company_allows_sub_companies = session.appState.activeCompany.allow_sub_companies || false;

  /* link cards */
  const reseller_card = {
    title: "Reseller Settings",
    description: "View Reseller Settings and Options.",
    url: "/reseller-settings"
  };
  const external_destinations_card = {
    title: "External Destinations",
    description: "Find, edit, or create external destinations.",
    url: "/external-destinations"
  };

  /* add link cards based on user and company permissions */
  if(access('reseller_settings') && current_company_allows_sub_companies) {
    settingsLinks.push(reseller_card);
  }

  if(access('external_destinations') && allowsExternalDestinations) {
    settingsLinks.push(external_destinations_card);
  }

  useEffect(() => {
    setAllowsExternalDestinations(companyHasExternalDestinations);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /* if no links to display: show message */
  if(!settingsLinks.length) {
    return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <h1>Company Settings</h1>
        </div>
        <div className="admin-links mt-5">
          <h4>No Settings Available.</h4>
        </div>
      </div>
    )
  }
  
  return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <h1>Company Settings</h1>
        </div>
        <div className="admin-links mt-5">
          {
            settingsLinks.map((card) => {
              return (
                <LinkCard
                  title={card.title}
                  description={card.description}
                  url={card.url || null}
                  key={card.title}
                  action={card.action || null}
                  action_label={card.action_label || null}
                />
              )
            })
          }
        </div>
      </div>
  )
}


const LinkCard = ({title, description, url, action, action_label}) => {
  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <p className="card-text">{description}</p>
        {
          !action ?
            <Link to={url}>
              <Button className="new-button">Open</Button>
            </Link>
          : 
          <Button
            type="button"
            onClick={action} 
            className="new-button">
            {action_label}
          </Button>
        }
      </div>
    </div>
  );
};
